import React, { FC } from 'react';

import dataLayer from '@rover/globals/dataLayer';
import { Box, Heading, Link } from '@rover/kibble/core';
import useFooterShim from '@rover/shared/js/hooks/useFooterShim';

const triggerHelpCenterLinkEvent = (): void => {
  dataLayer?.push({
    event: 'navigation-help',
  });
};

const NeedHelp: FC = () => {
  const { footer } = useFooterShim();
  const { helpLinks } = footer || {};

  if (!helpLinks?.visible) return null;
  return (
    <Box maxWidth={['none', '25%']} display={['none', 'block']}>
      <Heading size="300" my="6x" as="div">
        {helpLinks.name}
      </Heading>
      <Box>
        {helpLinks.items.map((item) => (
          <Link
            variant="secondary"
            underline={false}
            size="100"
            mb="1x"
            key={item.name}
            href={item.url}
            onClick={triggerHelpCenterLinkEvent}
          >
            {item.name}
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default NeedHelp;
